import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { h } from 'vue'

function resolveVNode(payload) {
  return typeof payload === 'string'
    ? payload
    : h(payload.component, payload.props)
}

function getThemeFromRoot() {
  const root = document.querySelector('.talent')
  return root?.classList.contains('dark') ? 'light' : 'dark'
}

export default {
  install(app) {
    app.use(Vue3Toastify, {
      autoClose: 4000,
      position: 'bottom-center',
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: true,
      draggablePercent: 0.6,
      icon: false,
      newestOnTop: true,
      expandCustomProps: true
    })

    app.config.globalProperties.$toast = {
      success(payload) {
        toast.success(resolveVNode(payload), { theme: getThemeFromRoot() })
      },
      error(payload) {
        toast.error(resolveVNode(payload), { theme: getThemeFromRoot() })
      },
      info(payload) {
        toast.info(resolveVNode(payload), { theme: getThemeFromRoot() })
      },
      warning(payload) {
        toast.warning(resolveVNode(payload), { theme: getThemeFromRoot() })
      }
    }
  }
}

